import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Tone = 'sage' | 'coral' | 'gold' | 'lav' | 'neutral';

const TONE: Record<Tone, string> = {
  sage: 'bg-sage-lt text-sage-dk',
  coral: 'bg-peach text-coral',
  gold: 'bg-gold-lt text-gold',
  lav: 'bg-lav-lt text-lav',
  neutral: 'bg-sand text-brown-md',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
